// extracted by mini-css-extract-plugin
export default {"section":"Section_section__r1S3j","content":"Section_content__giCbz"};